var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 2.5C3 1.13281 4.09375 0 5.5 0H11.9453C12.6094 0 13.2344 0.273438 13.7031 0.742188L17.2578 4.29688C17.7266 4.76562 18 5.39062 18 6.05469V17.5C18 18.9062 16.8672 20 15.5 20H5.5C4.09375 20 3 18.9062 3 17.5V2.5ZM16.125 17.5V6.25H13C12.2969 6.25 11.75 5.70312 11.75 5V1.875H5.5C5.14844 1.875 4.875 2.1875 4.875 2.5V17.5C4.875 17.8516 5.14844 18.125 5.5 18.125H15.5C15.8125 18.125 16.125 17.8516 16.125 17.5Z",
    fill: "#404040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/Document.d46d90e3f8513e2271491dcf53b13a25.svg";
export { ForwardRef as ReactComponent };